import { render, staticRenderFns } from "./skeleton_note.vue?vue&type=template&id=f7437d74&vue3"
import script from "./skeleton_note.vue?vue&type=script&lang=js&vue3"
export * from "./skeleton_note.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports